import MainLayout from '../layout/MainLayout';
import { FeedPage } from '../pages/private/Dashboard';
import { PaymentSheetsPageWrapper } from '../pages/private/PaymentSheets';
import { ProfilePageWrapper } from '../pages/private/Profile';
import { TimeSheetsPageWrapper } from '../pages/private/TimeSheet';
import { CodeConductPageWrapper } from '../pages/private/CodeConduct';
import { ROUTES } from './routes';

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: ROUTES.authenticated.dashboard,
      element: <FeedPage />
    },
    {
      path: ROUTES.authenticated.user.profile,
      element: <ProfilePageWrapper />
    },
    {
      path: ROUTES.authenticated.registers.birthdays,
      element: <div>Birthdays</div>
    },
    {
      path: ROUTES.authenticated.registers.paymentsheet,
      element: <PaymentSheetsPageWrapper />
    },
    {
      path: ROUTES.authenticated.registers.timesheet,
      element: <TimeSheetsPageWrapper />
    },
    {
      path: ROUTES.authenticated.registers.codeconduct,
      element: <CodeConductPageWrapper />
    }
  ]
};

export default MainRoutes;
